export function instagramErrorMessage(code: string): string {
  switch (code) {
    case 'oauth_state_invalid':
      return 'جلسه اتصال منقضی شده یا نامعتبر است. لطفاً دوباره تلاش کنید.';
    case 'oauth_denied':
      return 'اتصال لغو شد. شما دسترسی را در اینستاگرام رد کردید.';
    case 'oauth_code_exchange_failed':
      return 'تایید هویت با اینستاگرام ناموفق بود. لطفاً دوباره تلاش کنید.';
    case 'oauth_token_exchange_failed':
      return 'دریافت توکن امن از اینستاگرام ناموفق بود. لطفاً دوباره تلاش کنید.';
    case 'instagram_account_lookup_failed':
      return 'دریافت اطلاعات حساب اینستاگرام ناموفق بود. لطفاً دوباره تلاش کنید.';
    case 'instagram_subscription_failed':
      return 'حساب متصل شد اما فعال‌سازی رویدادها ناموفق بود. تنظیمات Webhook را در داشبورد متا بررسی کنید.';
    case 'instagram_configuration_missing':
      return 'اتصال اینستاگرام هنوز توسط مدیر سیستم پیکربندی نشده است.';
    case 'instagram_connection_failed':
      return 'اتصال حساب اینستاگرام ناموفق بود. لطفاً دوباره تلاش کنید.';
    default:
      return 'خطای غیرمنتظره‌ای رخ داد. لطفاً دوباره تلاش کنید.';
  }
}
